import Box from "@mui/material/Box";
import { Controller, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ENTERPRISE_INTAKE_OTHER_PLACEHOLDER } from "../../../../i18n/keysTranslations";
import CheckGroup from "../../../PreActivation/components/CheckGroup";
import FieldBlock from "../../../PreActivation/components/FieldBlock";
import FieldError from "../../../PreActivation/components/FieldError";
import FieldHint from "../../../PreActivation/components/FieldHint";
import FieldLabel from "../../../PreActivation/components/FieldLabel";
import IntakeTextField from "../../../../components/Form/IntakeTextField";

const CheckboxGroupWithOtherField = ({
  name,
  otherName,
  labelKey,
  hintKey,
  required = false,
  options,
  control,
  errors,
  readOnly,
}) => {
  const { t } = useTranslation();
  const value = useWatch({ control, name });

  return (
    <FieldBlock>
      <FieldLabel htmlFor={name} text={t(labelKey)} required={required} />
      {hintKey ? <FieldHint text={t(hintKey)} /> : null}
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <>
            <CheckGroup
              name={name}
              options={options}
              selectedValues={field.value}
              onChange={field.onChange}
              readOnly={readOnly}
            />
            <FieldError message={fieldState.error?.message} />
          </>
        )}
      />
      {Array.isArray(value) && value.includes("other") ? (
        <Box sx={{ mt: 1 }}>
          <IntakeTextField
            name={otherName}
            control={control}
            rules={{}}
            errors={errors}
            fullWidth
            readOnly={readOnly}
            placeholder={t(ENTERPRISE_INTAKE_OTHER_PLACEHOLDER)}
            variant="outlined"
          />
        </Box>
      ) : null}
    </FieldBlock>
  );
};

export default CheckboxGroupWithOtherField;
